const MailIcon = ({dimension = 24}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={dimension}
      height={dimension}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.58947 16.25C3.16849 16.25 2.81217 16.1042 2.52051 15.8125C2.22884 15.5208 2.08301 15.1645 2.08301 14.7435V5.25646C2.08301 4.83549 2.22884 4.47917 2.52051 4.1875C2.81217 3.89583 3.16849 3.75 3.58947 3.75H16.4099C16.8309 3.75 17.1872 3.89583 17.4788 4.1875C17.7705 4.47917 17.9163 4.83549 17.9163 5.25646V14.7435C17.9163 15.1645 17.7705 15.5208 17.4788 15.8125C17.1872 16.1042 16.8309 16.25 16.4099 16.25H3.58947ZM9.99967 10.4648L3.33301 6.20188V14.7435C3.33301 14.8184 3.35704 14.8799 3.40509 14.9279C3.45315 14.976 3.51461 15 3.58947 15H16.4099C16.4847 15 16.5462 14.976 16.5943 14.9279C16.6423 14.8799 16.6663 14.8184 16.6663 14.7435V6.20188L9.99967 10.4648ZM9.99967 9.16667L16.5382 5H3.46113L9.99967 9.16667ZM3.33301 6.20188V5V14.7435C3.33301 14.8184 3.35704 14.8799 3.40509 14.9279C3.45315 14.976 3.51461 15 3.58947 15H3.33301V6.20188Z"
        fill="#525252"
      />
    </svg>
  );
};
export default MailIcon;
